<template>
  <div id="contact">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'contact'
  }

</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/portal/situation/contact/Contact.vue